import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageChoice } from './language_choice';
import {IonicModule} from '@ionic/angular';

@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  declarations: [LanguageChoice],
  entryComponents: [LanguageChoice],

})
export class LanguageChoiceModule { }
